class UrlParams {
    static create(searchString) {
        return new UrlParams(searchString);
    }

    constructor(searchString) {
        this.params = new URLSearchParams(searchString);
    }

    getActivateUser() {
        return this.getParam('activateUser');
    }

    getConfirmUsername() {
        return this.getParam('confirmUsername');
    }

    getInstitution() {
        return this.getParam('institution');
    }

    getParam(param) {
        return this.params.get(param);
    }

    getTestMinutesUntilDown() {
        return this.getParam('test-minutes-until-down');
    }

    hasActivateUser() {
        return this.getActivateUser() !== null;
    }

    hasConfirmUsername() {
        return this.getConfirmUsername() !== null;
    }

    hasInstitution() {
        return this.getInstitution() !== null;
    }

    hasTestMinutesUntilDown() {
        return this.getTestMinutesUntilDown() !== null;
    }
}

export default UrlParams;